import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { ILopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/ILopTinChiSelectRequest";
import { ILopTinChiViewModel } from "../../../model/respone/lop-tin-chi/ILopTinChiViewModel";
import { IMonTinChi } from "../../../model/respone/lop-tin-chi/IMonTinChi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLopTinChiActionsObj = {
  LOAD_START: {} as ILopTinChiSelectRequest,
  LOAD_SUCCESS: {} as ILopTinChiViewModel[],
  LOAD_ERRR: "",
  CHANGE_FILTER: {} as ILopTinChiSelectRequest,
  CHANGE_FOCUSED_ID: 0,

  CHANGE_SELECTED_IDS: {} as number[],

  INI_BY_KE_HOACH_START: {} as ILopTinChiSelectRequest,
  INI_BY_KE_HOACH_SUCCESS: undefined,
  INI_BY_KE_HOACH_ERROR: "",

  DELETE_START: {} as IIdsRequest,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",
  
  SAVE_START: {} as ILopTinChiViewModel,
  SAVE_SUCCESS: {} as ILopTinChiViewModel,
  SAVE_ERROR: "",

  SHOW_EDIT_MODAL: {} as ILopTinChiViewModel | undefined,
  CLOSE_EDIT_MODAL: undefined,

  UPDATE_PHAM_VI:{} as any,


  LOAD_BY_KE_HOACH_MON_START: {} as ILopTinChiSelectRequest,
  LOAD_BY_KE_HOACH_MON_SUCCESS: {} as ILopTinChiViewModel[],
  LOAD_BY_KE_HOACH_MON_ERROR: "",


  LOAD_BY_DOT_THI_DANG_KY_START: {} as number,
  LOAD_BY_DOT_THI_DANG_KY_SUCCESS: {} as ILopTinChiViewModel[],
  LOAD_BY_DOT_THI_DANG_KY_ERROR: "",

  UPDATE_MON_TIN_CHI_START: {} as IMonTinChi,
  UPDATE_MON_TIN_CHI_SUCCESS: {} as IMonTinChi,
  UPDATE_MON_TIN_CHI_ERROR: "",

  DANG_KY_TU_DONG_LOP_HANH_CHINH_START: {} as number[],
  DANG_KY_TU_DONG_LOP_HANH_CHINH_SUCCESS: undefined,
  DANG_KY_TU_DONG_LOP_HANH_CHINH_ERROR: "",

};
export const eLopTinChiActionIds = generateActionTypeIds(
  eLopTinChiActionsObj,
  "LOP_TIN_CHI"
);
export type ILopTinChiActionTypes = IGenericActionType<
  typeof eLopTinChiActionsObj,
  "LOP_TIN_CHI"
>;
